export default ({withIcons, availabilityText, waitingText, helpButtonHTML}) => `
<div class='CopiesAvailable'>
    ${availabilityText ? `
        <div class='availability'>
            <span class='availabilityText'>
                ${withIcons ? '<i class="icon-copies" aria-hidden="true"></i>' : '' }
                ${availabilityText}
            </span>
            ${!waitingText && helpButtonHTML ? `
                <span>
                    ${helpButtonHTML}
                </span>
            ` : ''}
        </div>
    ` : ''}
    ${waitingText ? `
        <div class='waiting'>
            <span>
                ${withIcons ? '<i class="icon-holds" aria-hidden="true"></i>' : '' }
                ${waitingText}
            </span>
            ${helpButtonHTML ? `
                <span>
                    ${helpButtonHTML}
                </span>
            ` : ''}
        </div>
    ` : ''}
</div>
`;
